import React from 'react';

export default function EmailFooterBlock({ props }) {
  return (
    <div style={{
      padding: props.padding || '24px',
      backgroundColor: props.background_color || '#f5f5f4',
      textAlign: 'center',
      fontSize: props.font_size || '11px',
      color: props.text_color || '#78716c',
      lineHeight: '1.6',
    }}>
      {props.company_name && <p style={{ margin: '0 0 4px', fontWeight: 600 }}>{props.company_name}</p>}
      {props.address && <p style={{ margin: '0 0 8px' }}>{props.address}</p>}
      <p style={{ margin: 0 }}>
        <a href={props.unsubscribe_url || '#'} onClick={e => e.preventDefault()}
          style={{ color: props.text_color || '#78716c', textDecoration: 'underline' }}>
          {props.unsubscribe_text || 'Unsubscribe'}
        </a>
      </p>
    </div>
  );
}
